<template>
  <!--  v-show="bindSaasPop.isShow" -->

  <div
    v-show="bindSaasPop.isShow"
    class="bind-saas-pop"
    data-compname="bindSaasPop"
    @click="onClickPop"
  >
    <!-- 绑定企鹅小店 -->
    <BindMkPop v-show="bindSaasPop.type === 1" />
    <!-- 绑定京东 -->
    <BindJdPop v-if="bindSaasPop.type === 2 && bindSaasPop.isShow" />
    <!-- 修改京东 PID -->
    <EditorJdPop v-show="bindSaasPop.type === 4" :data="bindSaasPop.bindStateTemplate" />
    <!-- 编辑企鹅小店 -->
    <EditorQePop v-show="bindSaasPop.type === 5" :data="bindSaasPop.bindStateTemplate" />
    <!-- 绑定拼多多 -->
    <BindPddPop v-show="bindSaasPop.type === 3" />
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import { mapState } from 'vuex';
import BindJdPop from './bindJdPop';
import BindMkPop from './bindMkPop';
import BindPddPop from './bindPddPop';
import EditorJdPop from './editorJdPop';
import EditorQePop from './editorQePop';

export default {
  name: 'AddGoodsPop',
  components: {
    BindJdPop,
    BindMkPop,
    BindPddPop,
    EditorJdPop,
    EditorQePop,
  },
  mixins: [commonMixin],
  data() {
    return {
      isClickJdBind: false,
      showBubble: false,
      jdPid: '',
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindSaasPop: state => state.common.bindSaasPop,
    }),
    mkBindQrcode() {
      return this.getBindUrl('mk');
    },
    jdBindUrl() {
      return this.getBindUrl('jd');
    },
    pddBindUrl() {
      return this.getBindUrl('pdd');
    },
  },
  watch: {
    showBubble() {
      setTimeout(() => {
        document.querySelector('.popup').classList.add('popup-1');
      }, 0);
    },
  },
  methods: {
    getBindUrl(saasType) {
      const bindInfo = this.profile.saas_binding.filter(item => item && item.mask === saasType)[0];
      return bindInfo ? bindInfo.authenticate_entry : '';
    },
    toggleBubble() {
      this.showBubble = !this.showBubble;
    },
    goToJdBindPage() {
      if (!this.jdBindUrl) {
        this.$tip.error('京东绑定URL不存在');
        return;
      }

      window.open(this.jdBindUrl);
      this.isClickJdBind = true;
    },
    goToPddBindPage() {
      if (!this.pddBindUrl) {
        this.$tip.error('拼多多绑定URL不存在');
        return;
      }

      window.open(this.pddBindUrl);
    },
    onClose() {
      console.log('close');
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
      this.showBubble = false;
    },
    async confirmBindJd() {
      if (!this.jdPid) {
        this.$tip({
          message: 'jdPid不能为空',
          type: 'error',
        });

        return;
      }

      await this.bindJdPid(this.jdPid);
      this.$store.dispatch('userCenter/fetchCpProfile');
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
    onClickPop() {
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.bind-saas-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.3);
  .pop-content {
    width: 800px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }

  .tip-wrap {
    display: flex;
    align-items: center;
    margin-top: 15px;
    color: #707070;
    font-size: 12px;
    .icon-tip {
      width: 20px;
      margin-right: 4px;
    }
  }

  .label {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .panel {
    text-align: center;
  }
  .item {
    position: relative;
    display: inline-block;
    .input-wrap {
      position: relative;
      padding: 10px;
      box-sizing: border-box;
      width: 460px;
      & > .bind-item {
        padding: 10px;
      }
    }
  }
}
</style>

<style lang="less">
.bind-saas-pop {
  .header {
    font-size: 16px;
  }
  .tc-15-input-text.m {
    width: 300px;
    border-color: #9b9b9b;
  }
  .tc-15-input-text.xl {
    width: 100%;
    border-radius: 4px;
  }
  .tc-15-btn.m {
    margin: 0 10px;
    height: 40px;
    border-radius: 4px;
    &.btn-add-jd {
      border-color: 1px solid #fff;
      background-color: #fff;
      color: var(--ui-main-color);
    }
  }
  .input-wrap {
    & > * {
      font-size: 15px;
    }
    .tc-15-btn.m {
      height: 30px;
      border-color: 1px solid #fff;
      background-color: #fff;
      color: var(--ui-main-color);
      border-radius: 4px;
    }
    .bind-item {
      min-height: 100px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .desc {
        flex: 1;
        margin-right: 20px;
      }
    }
    .error-tip {
      color: #e1251b;
      margin-top: 15px;
      text-align: left;
      font-size: 13px;
    }
  }
  .qrcode {
    width: 350px;
  }
}

.popup-1 {
  max-width: inherit !important;
  width: 480px !important;
  .bind-item {
    display: flex;
    align-items: center;
    .desc {
      flex: 1;
    }
  }
  .error-tip {
    color: #e1251b;
    margin-top: 6px;
    text-align: left;
  }
  .tc-15-btn.m {
    border-color: 1px solid #fff;
    background-color: #fff;
    color: var(--ui-main-color);
    border-radius: 4px;
  }
}

.tc-15-input-text-wrap.m .tc-15-input-text,
.tc-15-input-text.m {
  flex: 1;
  margin-right: 10px;
}
</style>
